var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-root"},[(_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }